import {createStore} from 'vuex'

import PocketBase from 'pocketbase';
import moment from "moment";

const host = import.meta.env.PROD ? window.location.origin : import.meta.env.VITE_APP_CLIENT_POCKETBASE_URL ?? '/pb';
const pb = new PocketBase(host);
//const pb = new PocketBase(import.meta.env.PROD ? window.location.origin : import.meta.env.VITE_APP_CLIENT_POCKETBASE_URL ?? '/pb');


export default createStore({
	state: {
		id: null,
		leaves: [],
		ticketDatas: {},
		category: null,
		base64Img: null,
		user: null,
		displayName: null,
		isdev: import.meta.env.APP_ENV !== 'prod' && import.meta.env.APP_ENV !== 'production' && import.meta.env.APP_ENV !== 'PROD' && !import.meta.env.PROD,
	},
	mutations: {
		SET_ID(state, data) {
			state.id = data;
		},
		SET_DISPLAY_NAME(state, name) {
			state.displayName = name;
		},
		SET_TICKET_DATA(state, data) {
			state.ticketDatas = data;
		},
		SET_CATEGORY(state, category) {
			state.category = category;
		},
		SET_BASE64_IMG(state, img) {
			state.base64Img = img;
		},

		SET_LEAVES(state, leaves) {
			state.leaves = leaves;
		},
		SET_USER(state, user) {
			state.user = user;
		},
	},
	actions: {
		setId({state, commit}, value) {
			commit('SET_ID', value);
		},
		setCategory({state, commit}, value) {
			commit('SET_CATEGORY', value);
		},
		setTicketDatas({state, commit}, value) {
			commit('SET_TICKET_DATA', value);
		},
		setBase64Img({state, commit}, value) {
			commit('SET_BASE64_IMG', value);
		},

		/***** METHODS *****/
		loginWithInput: async function (store, data) {
			try {
				const authData = await pb.collection('users').authWithPassword(data.login, data.password);

				if (pb.authStore.isValid) {
					store.commit('SET_USER', pb.authStore.model);
					store.commit('SET_DISPLAY_NAME', pb.authStore.model.name);
					return true;
				}

			} catch (e) {
				console.log(e);
				return false;
			}


		},
		login: async function (store, data) {
			const authData = await pb.collection('users').authWithOAuth2({provider: 'microsoft'});

			const meta = authData.meta;

			if (meta.isNew) {
				const formData = new FormData();
				if (meta.avatarUrl) {
					const response = await fetch(meta.avatarUrl);

					if (response.ok) {
						const file = await response.blob();
						formData.append('avatar', file);
					}
				}

				formData.append('name', meta.name);

				// mise a jour de l'avatart et du nom de l'utilisateur une fois authentifé
				await pb.collection('users').update(authData.record.id, formData);
			}

			// Mise à jour du state après la connexion
			store.commit('SET_USER', pb.authStore.model);
			store.commit('SET_DISPLAY_NAME', pb.authStore.model.name);

		},
		refresh: async function (store) {
			await pb.collection('users').authRefresh({});
		},

		logout: function () {
			pb.authStore.clear();
		},
		setUser: async function (store, data) {
			if (!data) {
				store.commit('SET_USER', pb.authStore.model);
				store.commit('SET_DISPLAY_NAME', pb.authStore.model.name);
				return;
			}

			const userId = pb.authStore.model.id;
			let updatedUser;

			if (data instanceof FormData) {
				updatedUser = await pb.collection('users').update(userId, data);
			} else {
				updatedUser = await pb.collection('users').update(userId, data);
			}

			store.commit('SET_USER', updatedUser);
			store.commit('SET_DISPLAY_NAME', updatedUser.name);
		},
		// check if user is authenticated and set user data
		checkAuth: function (store) {
			if (pb.authStore.isValid) {
				store.commit('SET_USER', pb.authStore.model);
				store.commit('SET_DISPLAY_NAME', pb.authStore.model.name);
				return true;
			}
			return false;
		},

		async newleaves(store, data) {
			if (pb.authStore.model) {
				data.applicant = pb.authStore.model.id;
			}

			data.status = 'pending';
			const formData = new FormData();

			// Ajout des données de base
			formData.append('applicant', data.applicant);
			formData.append('status', data.status);
			formData.append('type', data.type);
			formData.append('start', data.start);
			formData.append('end', data.end);
			formData.append('comment', data.comment);
			if (data.extraordinaryType) {
				formData.append('extraordinaryType', data.extraordinaryType);
			}

			// Gestion des fichiers
			if (data.files && data.files.length > 0) {
				for (let file of data.files) {
					formData.append('justificatifs', file.file);
				}
			}

			return await pb.collection('leaves').create(formData);
		},
		async fetchLeaves({commit}) {
			//const start = moment(params.date).startOf('month').format('YYYY-MM-DD HH:mm:ss');
			//const end = moment(params.date).endOf('month').format('YYYY-MM-DD HH:mm:ss');
			//let filter = `category = "${params.category}" && date >= "${start}" && date <= "${end}"`;

			const filter = `applicant = "${pb.authStore.model.id}"`;

			let leaves = await pb.collection('leaves').getFullList({
				expand: "applicant,validator",
				filter: filter,
				sort: '-created'
			});

			let getImageURL = function (collectionID, recID, filename) {
				return `${host}/api/files/${collectionID}/${recID}/${filename}`;
			};

			for (let leave in leaves) {
				if (leaves[leave].justificatifs) {
					let files = leaves[leave].justificatifs;
					leaves[leave].justificatifs = [];
					for (let justificatif in files) {
						leaves[leave].justificatifs.push({
								title: files[justificatif],
								url: getImageURL(leaves[leave].collectionId, leaves[leave].id, files[justificatif]),
							}
						);
					}
				}
			}

			commit('SET_LEAVES', leaves)
		},

		async cancelLeave(store, leaveid) {

			const data = {
				cancel_at: moment().format('YYYY-MM-DD HH:mm:ss'),
				status: 'canceled'
			}
			await pb.collection('leaves').update(leaveid, data);
			store.dispatch('fetchLeaves');

		},

		async cancelLeaveByValidator(store, {id, comment}) {

			const data = {
				validatorcomment: comment,
				validator: store.state.user.id,
				cancel_at: moment().format('YYYY-MM-DD HH:mm:ss'),
				status: 'canceled',
			}
			await pb.collection('leaves').update(id, data);

		},

		async validateLeaveByValidator(store, {id, comment}) {

			const data = {
				validatorcomment: comment,
				validator: store.state.user.id,
				validate_at: moment().format('YYYY-MM-DD HH:mm:ss'),
				status: 'validated',
			}
			await pb.collection('leaves').update(id, data);
		},

		async refuellingLeaveByValidator(store, {id, comment}) {

			const data = {
				validatorcomment: comment,
				validator: store.state.user.id,
				refuelling_at: moment().format('YYYY-MM-DD HH:mm:ss'),
				status: 'refused',
			}

			await pb.collection('leaves').update(id, data);

		},

		async checkDuplicateExpense(store, {date, totalttc, excludeId}) {
			const amount = parseFloat(totalttc);
			if (!pb.authStore.model || !date || isNaN(amount)) {
				return [];
			}

			const day = moment(date).format('YYYY-MM-DD');
			const start = `${day} 00:00:00.000Z`;
			const end = `${moment(date).add(1, 'day').format('YYYY-MM-DD')} 00:00:00.000Z`;

			let filter = `user = "${pb.authStore.model.id}" && totalttc = ${amount} && date >= "${start}" && date < "${end}" && deleted != true`;
			if (excludeId) {
				filter += ` && id != "${excludeId}"`;
			}

			return await pb.collection('expense').getFullList({filter});
		},

		async createTicket(store, data) {
			let arr = data.picture.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[arr.length - 1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}

			const extensions = {
				'application/pdf': 'pdf',
				'image/jpeg': 'jpg',
				'image/jpg': 'jpg',
				'image/png': 'png',
				'image/webp': 'webp',
				'image/heic': 'heic',
				'image/heif': 'heif',
			};
			const extension = extensions[mime] || (mime.split('/')[1] || 'png').split(';')[0];

			data.picture = new File([u8arr], `ticket.${extension}`, {type: mime});

			if (pb.authStore.model) {
				data.user = pb.authStore.model.id;
			}

			if (data.id && data.id != undefined) {
				await pb.collection('expense').update(data.id, data);
				return;
			}

			// supprime id si la clé existe
			delete data.id;
			console.log(data, 'data to create ticket');

			await pb.collection('expense').create(data);

			store.commit('SET_TICKET_DATA', {});
			store.commit('SET_CATEGORY', '');

		},
		deleteTicket: async function (store, expenseid) {

			// change le champ delete avec la date du jour
			await pb.collection('expense').update(expenseid, {
				deleted: moment().toDate(),
			});

		},

		async getTicket(store, expenseid) {
			return await pb.collection('expense').getOne(expenseid, {
				expand: "user",
			});
		},
		async getScanUrl(store, expenseid) {
			const record = await pb.collection('expense').getOne(expenseid);
			const url = pb.files.getUrl(record, record.picture, {'thumb': '100x250'});

			let toDataURL = function (url) {
				return new Promise(resolve => {
					let xhr = new XMLHttpRequest();
					xhr.onload = function () {
						let reader = new FileReader();
						reader.onloadend = function () {
							resolve(reader.result);
						}
						reader.readAsDataURL(xhr.response);
					};
					xhr.open('GET', url);
					xhr.responseType = 'blob';
					xhr.send();
				})
			}

			return await toDataURL(url);
		},
	},
	getters: {
		getDisplayName: (state) => {
			return state.displayName;
		},

		getPb: (state) => {
			return pb;
		},
		getTicketDatas:
			(state) => {
				return state.ticketDatas;
			},
		getCategory:
			(state) => {
				return state.category;
			},
		getBase64Img:
			(state) => {
				return state.base64Img;
			},
		getUser:
			(state) => {
				return state.user;
			},
		getId:
			(state) => {
				return state.id;
			},
		getLeaves:
			(state) => {
				return state.leaves;
			},
		getIsDev:
			(state) => {
				return state.isdev;
			},
	}
})